import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Page, Pages, Routes } from 'src/app/core/routes/routes';

@Injectable({
    providedIn: 'root',
})
export class RoutingService {
    constructor(private router: Router) {}

    private static getPath(page: Page) {
        return Routes[page].path;
    }

    navigate(commands: (string | number)[], extras?: NavigationExtras) {
        return this.router.navigate(commands, extras);
    }

    goToRoute(page: Page, args?) {
        return this.router.navigate(args ? [RoutingService.getPath(page), ...args] : [RoutingService.getPath(page)]);
    }

    goToPage(page: Page, queryParams) {
        return this.router.navigate([RoutingService.getPath(page)], { queryParams });
    }

    goToErrorPage() {
        return this.router.navigate([Routes[Pages.TECHNISCHER_FEHLER].path], {
            skipLocationChange: true,
            queryParamsHandling: 'preserve',
        });
    }
}
